import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { LabelLarge, Textbox } from '@styled';
import colors from '@general/colors';
import Asterisk from '@atoms/Asterisk';

const GridContainerStyled = styled.div`
    display: grid;
    grid-column-gap: 12px;
    grid-template-columns: repeat(2, 1fr);
`;

// const LabelStyled = styled.label`
//     color: #30313d;
//     display: block;
//     font-family: 'Newsreader', serif;
//     font-size: 0.93rem;
//     margin-bottom: 4px;
// `;

// const TextBoxStyled = styled.input`
//     background-color: #f5f5f5;
//     border: 1px solid #dddddd;
//     border-radius: 5px;
//     box-shadow: 0px 1px 1px rgb(0 0 0 / 3%), 0px 3px 6px rgb(0 0 0 / 2%);
//     color: #30313d;
//     font-family: 'Newsreader', serif;
//     padding: 0.75rem;

//     &::placeholder {
//         color: #949fa8;
//     }
// `;

const CardNameForm = ({ disabled = false, onFirstNameChange, onLastNameChange }) => {
    return (
        <GridContainerStyled>
            <div className="col-span-1">
                <label htmlFor="firstName">
                    <LabelLarge>
                        First Name on Card <Asterisk />
                    </LabelLarge>
                </label>

                <Textbox
                    disabled={disabled}
                    maxLength="100"
                    name="firstName"
                    required
                    type="text"
                    onChange={e => onFirstNameChange(e.target.value)}
                />
            </div>

            <div className="col-span-1">
                <label htmlFor="lastName">
                    <LabelLarge>
                        Last Name on Card <Asterisk />
                    </LabelLarge>
                </label>

                <Textbox
                    disabled={disabled}
                    maxLength="100"
                    name="lastName"
                    required
                    type="text"
                    onChange={e => onLastNameChange(e.target.value)}
                />
            </div>
        </GridContainerStyled>
    );
};

CardNameForm.propTypes = {
    disabled: PropTypes.bool,
    onFirstNameChange: PropTypes.func.isRequired,
    onLastNameChange: PropTypes.func.isRequired,
};

export default CardNameForm;
